var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"text-left fixed-bottom",attrs:{"cols":"12"}},[_c('hr'),_vm._v(" BrevisVelox"),_c('sup',[_vm._v("©")]),_vm._v(" 2020 ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }